import { ApiGet } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '../stores/SettingsStore.ts'
import type {
  IConsultantResponse,
  IConsultantClassCheckResponse
} from '../types/ConsultantTypes.ts'


export async function ConsultantGet(beeNumber: number): Promise<IConsultantResponse> {
  const url = await GetOrderEntryConnectorUrl('ConsultantGet')
  return ApiGet(url, { beeNumber })
}

export async function ConsultantClassCheck(emailAddress: string): Promise<IConsultantClassCheckResponse> {
  const url = await GetOrderEntryConnectorUrl('ConsultantClassCheck')
  return ApiGet(url, { emailAddress })
}
